export default __webpack_public_path__ + "static/media/edituserBG.abc053ec.jpg";